// extracted by mini-css-extract-plugin
export default {"fullWidth":"Im-z","image":"Jm-z","lazyLoadPicture":"Km-z","lazyLoadSpinner":"Lm-z","lazyLoadSpin":"Mm-z","lazyLoadImage":"Nm-z","hasStyledAspectRatio":"Om-z"};